import type { Logger } from "@expert/logging";
import type { CallCategory } from "@expert/shared-types";

import { useGuideStore } from "./useGuideStore";

export const setRecommendation = (logger: Logger, sessionId: string, recommendation?: CallCategory | string) => {
    useGuideStore.getState().setRecommendation(sessionId, recommendation);
    logger.info({ recommendation, sessionId }, "Solve Guide | Guided flow recommendation set");
};

export const clearRecommendation = (logger: Logger, sessionId: string) => {
    useGuideStore.getState().clearRecommendation(sessionId);
    logger.info({ sessionId }, "Solve Guide | Guided flow recommendation cleared");
};
